import {
  getUrlParameter,
  getBootstrapData,
  isNullOrUndefined,
} from '$shared/utils.js';

export function getInitialState() {
  const notice = getBootstrapData('donate_error', true) || null;
  const inboundVia = getUrlParameter('via') || 'unknown';

  // Cover fees should always start as false, even if it was agreed to
  // initially and this is a page refresh. The backend stores the amount
  // that will actually be paid, not the amount without the fees, so the
  // amount being passed in here either already includes the fees and they
  // shouldn't be included again, or it doesn't because the donor didn't
  // opt in and it should be remain that way.
  const coverFees = false;

  return {
    coverFees,
    notice,
    inboundVia,
    error: null,
    ...getContactInfo(),
    ...getPaymentState(),
    ...getDonationState(),
    ...getInitialStepState(),
  };
}

function getInitialStepState() {
  const correctionStep = getUrlParameter('donate_step') || null;
  let step = 'intent';
  let completedSteps = [];

  if (correctionStep === 'contact') {
    step = 'contact';
    completedSteps = ['intent'];
  } else if (correctionStep === 'payment') {
    step = 'payment';
    completedSteps = ['intent', 'contact'];
  }

  return {
    step,
    completedSteps,
  };
}

function getDonationState() {
  const donation = getBootstrapData('donation', true) || {};
  let donationAmount = Number(donation.amount);
  if (Number.isNaN(donationAmount)) {
    donationAmount = 15;
  }

  let benefitDesired = donation.benefit_desired;
  if (isNullOrUndefined(benefitDesired)) {
    benefitDesired = true;
  }

  return {
    donationFrequency: donation.frequency || 'monthly',
    donationAmount,
    benefitDesired,
  };
}

function getContactInfo() {
  const donor = getBootstrapData('donor', true) || {};
  return {
    contactInfo: {
      firstName: donor.first_name || '',
      lastName: donor.last_name || '',
      email: donor.email || '',
      phone: donor.phone || '',
      address1: donor.address1 || '',
      address2: donor.address2 || '',
      country: donor.country || 'US', // default to US for now
      state: donor.state || '',
      city: donor.city || '',
      zip: donor.zip || '',
    },
  };
}

function getPaymentState() {
  const payment = getBootstrapData('payment', true) || {};

  return {
    paymentIntentId: payment.platform_id || null,
    clientSecret: getUrlParameter('client_secret') || null,
  };
}
